/* Amazing You buy box, behaviour for blocks/buy-box.liquid.
   One copy for every product page. Config comes from the block (JSON tags); this
   file never contains a price, a variant ID or a product name.
   The buy box never adds a gift line. Gifts are displayed here and delivered by
   the gift app on the trigger variant.

   3 Sep 2026 pass:
   - Pill blurbs. Pills are plain spans on unselected rungs and buttons on the
     selected one, so a tap on a card you have not chosen always selects it rather
     than opening a blurb. Hover on desktop, tap on mobile, same control.
   - Duplicate-variant guard. Two rungs resolving to the same variant means the
     wiring is wrong; the later one is dropped rather than shown at a price that
     belongs to another rung.
   - TIPS below are the one place with brand copy in this file. Override any of
     them from the block with cfg.tips.{origin,free} when those settings exist.

   11 Sep 2026 pass, legal:
   - No struck-through comparison price anywhere, on the rung card or the button.
   - compare_at_price is never read. A rung's saving is the difference between
     what it costs and what the same contents would cost bought another way, at
     prices we charge today. See referenceFor.
   - Savings in dollars throughout, never mixed with percentages in one buy box.
   - Unit price quoted per single unit, per ml or per g, or per use where the
     block sets a label such as night, day, bath or serve. Never per 100.

   11 Sep 2026 pass, sticky bar:
   - The sticky bar is moved onto the body at init. See the note by that line.
   - Its label follows the main button, so a sold out rung reads Sold out in both.

   11 Sep 2026 pass, layout:
   - The saving is a pill in the pill row rather than an element in the header,
     always last so it reads furthest right. The row is capped at three pills and
     the saving keeps its place, so earlier pills are trimmed first.
   - This file is deliberately pure ASCII. Do not introduce em dashes or other
     non-ASCII characters; use a JS escape if a symbol is needed in output. */
(function () {
  'use strict';

  var TIPS = {
    origin: 'Harvested straight from pristine inland salt lakes in Australia. Not made by diluting salts in water, pumped pure from the source.'
  };

  var SVG = {
    check: '<svg width="13" height="13" viewBox="0 0 16 16" aria-hidden="true"><path d="M3 8.4l3.3 3.3L13 5" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    gift:  '<svg width="15" height="15" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" aria-hidden="true"><rect x="1.8" y="6.4" width="12.4" height="7.8" rx="1"/><path d="M1.8 6.4h12.4M8 6.4v7.8M8 6.4S6.6 2 4.7 2.6 5.6 6.4 8 6.4zM8 6.4S9.4 2 11.3 2.6 10.4 6.4 8 6.4z"/></svg>',
    aus:   '<svg width="17" height="15" viewBox="0 0 32 28" fill="currentColor" aria-hidden="true"><path d="M4.2 10.5 7 7.6l4.5-2.4 1.7 2.6 1.8-2.2 2.2-2.4 1.2 3.4 2.6 1.6 3.6 2.8.8 3.8-2 3.6-3.8 2.2-3.4-1.2-3.6.8-3.8-1.2-3.4-3.4z"/><path d="M20 23.2l1.6-1 1.4 1.2-1 1.6z"/></svg>',
    truck: '<svg width="16" height="14" viewBox="0 0 18 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1 3.5h9v7H1zM10 6h3l2.5 2.5v2H10z"/><circle cx="4" cy="12" r="1.4"/><circle cx="12.5" cy="12" r="1.4"/></svg>',
    coin:  '<svg width="15" height="15" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="8" cy="8" r="6.2"/><path d="M8 5v6M6.3 6.6h3.4M6.3 9.4h3.4"/></svg>'
  };

  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
  function parseJSON(el) { try { return JSON.parse(el.textContent); } catch (e) { return null; } }
  function track(name, data) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, data));
    } catch (e) {}
  }

  function BuyBox(root) {
    var cfgEl = root.querySelector('script[data-ayb-config]');
    var cfg = cfgEl && parseJSON(cfgEl);
    if (!cfg) return;
    var tips = Object.assign({}, TIPS, cfg.tips || {});

    // Collect rungs. A rung with no resolved variant never renders (the Liquid
    // block sets variant: null and prints why in the theme editor). Two rungs on
    // the same variant is a wiring fault, not a valid ladder, so the later one is
    // dropped rather than shown carrying another rung's price.
    var rungs = [], seen = {}, dupes = [];
    Array.prototype.forEach.call(root.querySelectorAll('script[data-ayb-rung]'), function (el) {
      var r = parseJSON(el);
      if (!r || !r.variant || !r.variant.id) return;
      var id = String(r.variant.id);
      if (seen[id]) { dupes.push(r.title + ' repeats variant ' + id); return; }
      seen[id] = true;
      rungs.push(r);
    });
    if (dupes.length && window.console) console.warn('buy-box: duplicate rung variants dropped: ' + dupes.join('; '));
    rungs.forEach(function (r, i) { r.key = 'r' + (i + 1); });
    if (!rungs.length) return;

    var el = {
      label:   root.querySelector('[data-ayb="label"]'),
      modes:   root.querySelector('[data-ayb="modes"]'),
      modeTag: root.querySelector('[data-ayb="mode-tag"]'),
      sizes:   root.querySelector('[data-ayb="sizes"]'),
      heading: root.querySelector('[data-ayb="heading"]'),
      rungs:   root.querySelector('[data-ayb="rungs"]'),
      cta:     root.querySelector('[data-ayb="cta"]'),
      inst:    root.querySelector('[data-ayb="instalment"]'),
      error:   root.querySelector('[data-ayb="error"]'),
      trust:   root.querySelector('[data-ayb="trust"]'),
      sticky:  root.querySelector('[data-ayb="sticky"]')
    };

    // The buy box root carries container-type: inline-size. That makes it the
    // containing block for position: fixed descendants and traps their stacking
    // context, so the sticky bar was being positioned against the buy box rather
    // than the viewport and no z-index could lift it above the app sections
    // further down the page. Moving it onto the body frees both.
    if (el.sticky && el.sticky.parentNode !== document.body) document.body.appendChild(el.sticky);

    var mode = (cfg.modes.subscribe && cfg.modes.defaultMode === 'subscribe') ? 'subscribe' : 'onetime';
    var picked = rungs[Math.min(Math.max((cfg.defaultRung || 1) - 1, 0), rungs.length - 1)].key;
    var sizeId = cfg.sizeSwitch && cfg.sizeSwitch.enabled ? cfg.sizeSwitch.selected : null;
    var sym = (cfg.currency && cfg.currency.symbol) || '$';
    var openTip = null;

    function money(n) { return sym + (Math.round(n * 100) / 100).toFixed(2); }
    function current() { return rungs.filter(function (r) { return r.key === picked; })[0]; }
    function sizeVariant() {
      if (!sizeId || !cfg.sizeSwitch) return null;
      return cfg.sizeSwitch.variants.filter(function (v) { return String(v.id) === String(sizeId); })[0] || null;
    }
    function variantFor(r) {
      var sv = r.followSize ? sizeVariant() : null;
      return sv || r.variant;
    }
    function unitPrice(r) {
      var v = variantFor(r);
      if (mode === 'subscribe' && r.plan && r.plan.price != null && !r.followSize) return r.plan.price;
      if (mode === 'subscribe' && r.plan && r.plan.percent != null) return v.price * (1 - r.plan.percent / 100);
      return v.price;
    }
    function totalFor(r) { return unitPrice(r) * r.quantity; }
    function compareFor(r) { var v = variantFor(r); return (v.compareAt || v.price) * r.quantity; }
    function giftsFor(r) {
      var list = (cfg.promo && cfg.promo.active && r.promoGifts && r.promoGifts.length) ? r.promoGifts : (r.gifts || []);
      list = list.filter(function (g) { return g.available; });
      if (r.giftMode === 'subscribe' && mode !== 'subscribe') return [];
      if (!cfg.modes.subscribe && r.giftMode === 'subscribe') return [];
      return list;
    }
    function giftValue(r) { return giftsFor(r).reduce(function (s, g) { return s + (g.rrp || 0); }, 0); }
    function shipping(r) {
      var s = cfg.shipping;
      if (!s || !s.match) return { free: false, express: false };
      var t = totalFor(r);
      return { free: s.free != null && t >= s.free, express: s.freeExpress != null && t >= s.freeExpress };
    }
    function isAvailable(r) { var v = variantFor(r); return v && v.available !== false; }

    // Shipping copy is derived, never typed: the threshold and the country come
    // from the shop metafield and the viewer's market, so it stays true everywhere.
    function shippingTip(express) {
      var s = cfg.shipping || {};
      var amount = express ? s.freeExpress : s.free;
      if (amount == null) return '';
      var where = s.country ? ' across ' + s.country : '';
      return 'Orders over ' + money(amount) + ' qualify for free ' + (express ? 'express ' : '') + 'shipping' + where + '.';
    }
    function freeItemTip(r) {
      var f = (r.included || []).filter(function (x) { return x && x.free && x.qty > 0; });
      if (!f.length) return '';
      return f.map(function (x) { return 'A full ' + x.title + ', included free.'; }).join(' ');
    }

    function pillsFor(r, on) {
      var out = [];
      if (cfg.originPill) out.push({ text: cfg.originPill, icon: SVG.aus, cls: ' ayb-pill--origin', tip: tips.origin });
      var sh = shipping(r);
      if (sh.express) out.push({ text: 'Free Express Shipping', tip: shippingTip(true) });
      else if (sh.free) out.push({ text: 'Free Shipping', tip: shippingTip(false) });
      var g = giftsFor(r);
      if (g.length) out.push({ text: g.length + ' Free Gift' + (g.length > 1 ? 's' : '') });
      var freeItems = (r.included || []).filter(function (x) { return x && x.free && x.qty > 0; });
      if (freeItems.length) out.push({ text: r.freePill || 'Free Item', tip: freeItemTip(r) });
      // The saving is a pill like the others and always sits last, so it reads
      // furthest right. Three pills is the cap: if there are more, the saving keeps
      // its place and the earlier ones are trimmed.
      var save = savingFor(r);
      var savePill = save > 0.005 ? { text: 'Save ' + money(save), cls: ' ayb-pill--save' } : null;
      out = out.slice(0, savePill ? 2 : 3);
      if (savePill) out.push(savePill);
      if (!out.length) return '';
      var html = '<div class="ayb-pills">' + out.map(function (p, i) {
        var body = (p.icon || SVG.check) + esc(p.text);
        // Only the selected rung gets interactive pills, so a tap elsewhere selects.
        if (on && p.tip) {
          return '<button type="button" class="ayb-pill' + (p.cls || '') + '" data-tip="' + esc(p.tip) + '"'
            + ' aria-expanded="false" title="' + esc(p.tip) + '">' + body + '</button>';
        }
        return '<span class="ayb-pill' + (p.cls || '') + '">' + body + '</span>';
      }).join('') + '</div>';
      if (on) html += '<div class="ayb-tip" data-ayb="tip" hidden></div>';
      return html;
    }

    // What the same contents would cost bought another way, at prices we charge
    // today. Two cases, chosen by whether the rung declares a unit count:
    //   units > 0   volume rung: its volume priced at the entry rung's rate
    //   units == 0  mixed bundle: each component at its own price
    // Whichever is higher wins, so a rung can declare units purely to quote a
    // price per use without that wiping out a saving that comes from an included
    // item off another product.
    function unitCount(r) { return (r.units || 0) * (r.unitsPerQuantity ? r.quantity : 1); }
    function baseUnitPrice() {
      var b = rungs[0];
      if (!b) return 0;
      var n = unitCount(b);
      return n > 0 ? totalFor(b) / n : 0;
    }
    function includedValue(r) {
      var items = (r.included || []).filter(function (x) { return x && x.qty > 0; });
      if (!items.length) return 0;
      return items.reduce(function (s, x) { return s + (x.rrp || 0) * x.qty; }, 0);
    }
    function referenceFor(r) {
      var n = unitCount(r), bp = baseUnitPrice();
      var vol = (n > 0 && bp > 0) ? n * bp : 0;
      return Math.max(vol, includedValue(r));
    }
    // Dollars throughout, never mixed with percentages inside one buy box.
    // Rendered as the last pill by pillsFor, not as a separate element.
    function savingFor(r) { return referenceFor(r) - totalFor(r) + giftValue(r); }
    function tile(x, free, qty) {
      return '<div class="ayb-gift">'
        + (free ? '<span class="ayb-gift-badge">FREE</span>' : '')
        + (x.image ? '<img src="' + esc(x.image) + '" alt="" loading="lazy">' : '')
        + '<span class="ayb-gift-text"><b>' + (qty > 1 ? qty + ' &times; ' : '') + esc(x.title) + '</b>'
        + (x.product ? '<span>' + esc(x.product) + '</span>' : '')
        + '</span></div>';
    }
    function revealFor(r) {
      var items = (r.included || []).filter(function (x) { return x && x.qty > 0; });
      var g = giftsFor(r);
      if (!items.length && !g.length) return '';
      var label = items.length ? (cfg.includedLabel || "WHAT'S INCLUDED") : (g.length + ' FREE GIFT' + (g.length > 1 ? 'S' : '') + ' INCLUDED');
      var tiles = items.map(function (x) { return tile(x, !!x.free, x.qty); }).join('')
        + g.map(function (x) { return tile(x, true, 1); }).join('');
      return '<div class="ayb-reveal"><div class="ayb-rule"><span>' + SVG.gift + esc(label) + SVG.gift + '</span></div>'
        + '<div class="ayb-gifts">' + tiles + '</div>'
        + (g.length && mode === 'subscribe' && cfg.gifts && cfg.gifts.subscribeNote ? '<p class="ayb-gift-note">' + esc(cfg.gifts.subscribeNote) + '</p>' : '')
        + (g.length && cfg.gifts && cfg.gifts.note ? '<p class="ayb-gift-note">' + esc(cfg.gifts.note) + '</p>' : '')
        + '</div>';
    }
    function unitsFor(r) {
      var base = r.units;
      if (r.followSize && sizeVariant()) {
        var m = /([\d.]+)\s*(ml|l|g|kg)?/i.exec(sizeVariant().option || '');
        if (m) {
          var n = parseFloat(m[1]);
          if (m[2] && /^(l|kg)$/i.test(m[2])) n = n * 1000;
          if (n > 0) base = n;
        }
      }
      return base;
    }
    function plural(n, label) {
      if (n === 1 || /^(ml|g|kg|l)$/i.test(label)) return label;
      return label + 's';
    }
    // Always quoted per single unit: per ml, per g, per night. The smaller
    // figure reads better on a rung card than a per-100 equivalent, and it is
    // the same shape for every product, so rungs stay comparable.
    function unitText(per, label) {
      return money(per) + '/' + esc(label);
    }
    function unitLine(r, total) {
      if (!cfg.unit || !cfg.unit.show || !unitsFor(r)) return '';
      var n = unitsFor(r) * (r.unitsPerQuantity ? r.quantity : 1);
      var per = total / n;
      var label = cfg.unit.label || 'unit';
      var tight = /^(ml|g|kg|l)$/i.test(label);
      var left = r.sub ? r.sub : (n + (tight ? '' : ' ') + plural(n, label));
      return '<div class="ayb-meta"><p>' + esc(left)
        + (mode === 'subscribe' && r.cadence ? ' &middot; ' + esc(r.cadence) : '') + '</p>'
        + '<p class="ayb-unit">' + unitText(per, label) + '</p></div>';
    }

    function renderSizes() {
      if (!el.sizes || !cfg.sizeSwitch || !cfg.sizeSwitch.enabled) return;
      el.sizes.innerHTML = cfg.sizeSwitch.variants.map(function (v) {
        var on = String(v.id) === String(sizeId);
        return '<button type="button" class="ayb-size' + (on ? ' is-on' : '') + '" data-size="' + esc(v.id) + '"'
          + (v.available ? '' : ' disabled') + ' aria-pressed="' + on + '">' + esc(v.option) + '</button>';
      }).join('');
    }

    function render() {
      openTip = null;
      if (el.heading) el.heading.textContent = mode === 'subscribe' ? cfg.headings.subscribe : cfg.headings.onetime;
      if (el.modeTag) {
        var best = 0;
        rungs.forEach(function (r) {
          if (!r.plan) return;
          var sub = (r.plan.price != null ? r.plan.price : r.variant.price * (1 - (r.plan.percent || 0) / 100)) * r.quantity;
          best = Math.max(best, referenceFor(r) - sub);
        });
        el.modeTag.textContent = best > 0.5 ? 'UP TO ' + sym + Math.floor(best) + ' OFF' : '';
      }
      renderSizes();
      el.rungs.innerHTML = rungs.map(function (r) {
        var on = r.key === picked, total = totalFor(r), avail = isAvailable(r);
        var tag = (cfg.promo && cfg.promo.active && r.promoLabel) ? { text: r.promoLabel, promo: true } : (r.tag ? { text: r.tag } : null);
        var title = r.title;
        if (r.followSize && sizeVariant() && r.titleWithSize) title = r.titleWithSize.replace('{size}', sizeVariant().option);
        return '<div class="ayb-rung' + (on ? ' is-on' : '') + (avail ? '' : ' is-unavailable') + '" data-key="' + r.key + '"'
          + ' role="radio" tabindex="' + (on ? '0' : '-1') + '" aria-checked="' + on + '"' + (avail ? '' : ' aria-disabled="true"') + '>'
          + (tag ? '<span class="ayb-tag' + (tag.promo ? ' ayb-tag--promo' : '') + '">' + esc(tag.text) + '</span>' : '')
          + '<div class="ayb-top"><span class="ayb-dot"><i></i></span>'
          + (r.image ? '<span class="ayb-pic"><img src="' + esc(r.image) + '" alt="" loading="lazy"></span>' : '')
          + '<div class="ayb-main"><div class="ayb-head"><div class="ayb-titlerow"><p class="ayb-title">' + esc(title) + '</p></div>'
          + '<div class="ayb-cost">'
          + '<p class="ayb-price">' + money(total) + '</p></div></div>'
          + unitLine(r, total)
          + (r.sub && !(cfg.unit && cfg.unit.show && unitsFor(r)) ? '<div class="ayb-meta"><p>' + esc(r.sub) + '</p></div>' : '')
          + (!avail ? '<div class="ayb-meta"><p>Currently unavailable</p></div>' : '')
          + '</div></div>'
          + pillsFor(r, on)
          + (on ? revealFor(r) : '')
          + '</div>';
      }).join('');
      if (el.modes) {
        Array.prototype.forEach.call(el.modes.querySelectorAll('.ayb-mode'), function (b) {
          var on = b.getAttribute('data-mode') === mode;
          b.classList.toggle('is-on', on);
          b.setAttribute('aria-selected', String(on));
        });
      }
      var r = current(), total = totalFor(r), avail = isAvailable(r);
      var verb = mode === 'subscribe' ? cfg.cta.subscribe : cfg.cta.onetime;
      el.cta.innerHTML = avail
        ? esc(verb) + ' &middot; ' + money(total)
        : esc(cfg.cta.unavailable || 'Unavailable');
      el.cta.disabled = !avail;
      if (el.inst) {
        el.inst.textContent = (cfg.afterpay && mode === 'onetime' && total >= 1 && total <= 2000)
          ? 'or 4 payments of ' + money(total / 4) + ' with Afterpay' : '';
      }
      if (el.trust) {
        var items = [];
        (cfg.trust || []).forEach(function (t, i) {
          if (!t) return;
          var icon = [SVG.aus, SVG.truck, SVG.coin][i] || SVG.check;
          items.push('<span>' + icon + esc(t) + '</span>');
        });
        if (cfg.points && cfg.points.show && cfg.points.perDollar) {
          var pts = Math.round(total * cfg.points.perDollar / 5) * 5;
          items.push('<span>' + SVG.coin + '+' + pts + ' ' + esc(cfg.points.label || 'Points') + '</span>');
        }
        el.trust.innerHTML = items.join('');
      }
      renderSticky();
    }

    /* ---- gallery sync: behave like the theme's variant picker ---- */
    var galleryAbort = null, lastGalleryVariant = null, galleryCache = {};
    function galleryUrlFor(v) {
      var params = ['variant=' + encodeURIComponent(v.id)];
      var view = new URLSearchParams(location.search).get('view');
      if (view) params.push('view=' + encodeURIComponent(view));
      return cfg.productUrl.split('?')[0] + '?' + params.join('&');
    }
    function fetchGallery(v, signal) {
      if (galleryCache[v.id]) return Promise.resolve(galleryCache[v.id]);
      return fetch(galleryUrlFor(v), signal ? { signal: signal } : undefined)
        .then(function (res) { return res.text(); })
        .then(function (text) {
          var html = new DOMParser().parseFromString(text, 'text/html');
          galleryCache[v.id] = html;
          return html;
        });
    }
    function prefetchGalleries() {
      if (!cfg.syncGallery || !cfg.productUrl) return;
      var run = function () {
        rungs.forEach(function (r) {
          var v = variantFor(r);
          if (v && v.id && String(r.product && r.product.id) === String(cfg.productId)) fetchGallery(v).catch(function () {});
        });
      };
      if ('requestIdleCallback' in window) requestIdleCallback(run, { timeout: 2000 }); else setTimeout(run, 600);
    }
    function syncGallery() {
      if (!cfg.syncGallery || !cfg.productUrl) return;
      var r = current(), v = variantFor(r);
      if (!v || !v.id) return;
      if (String(r.product && r.product.id) !== String(cfg.productId)) return;
      if (String(v.id) === String(lastGalleryVariant)) return;
      lastGalleryVariant = v.id;
      try { if (galleryAbort) galleryAbort.abort(); } catch (e) {}
      galleryAbort = ('AbortController' in window) ? new AbortController() : null;
      fetchGallery(v, galleryAbort && galleryAbort.signal)
        .then(function (cached) {
          var html = cached.cloneNode(true);
          var ev;
          try { ev = new Event('variant:update', { bubbles: true }); } catch (e) { return; }
          ev.detail = {
            resource: { id: v.id, available: v.available !== false, featured_media: r.media || null },
            sourceId: root.id,
            data: { html: html, productId: String(cfg.productId) }
          };
          root.dispatchEvent(ev);
          try {
            var u = new URL(location.href); u.searchParams.set('variant', v.id);
            history.replaceState({}, '', u.toString());
          } catch (e) {}
        })
        .catch(function () {});
    }

    function renderSticky() {
      if (!el.sticky) return;
      var r = current(), total = totalFor(r);
      var img = el.sticky.querySelector('img');
      if (img) { if (r.image) { img.src = r.image; img.hidden = false; } else { img.hidden = true; } }
      var t = el.sticky.querySelector('[data-ayb="sticky-title"]');
      var s = el.sticky.querySelector('[data-ayb="sticky-sub"]');
      var b = el.sticky.querySelector('[data-ayb="sticky-cta"]');
      var title = r.title;
      if (r.followSize && sizeVariant() && r.titleWithSize) title = r.titleWithSize.replace('{size}', sizeVariant().option);
      if (t) t.textContent = title;
      if (s) s.textContent = (mode === 'subscribe' ? cfg.modes.labels.subscribe : cfg.modes.labels.onetime) + ' · ' + money(total);
      if (b) {
        // Match the main button. A sold out rung used to leave the sticky bar
        // reading Add to Cart, disabled but contradicting the button above it.
        b.textContent = isAvailable(r)
          ? (mode === 'subscribe' ? cfg.cta.subscribe : cfg.cta.onetime)
          : (cfg.cta.unavailable || 'Unavailable');
        b.disabled = !isAvailable(r);
      }
    }

    /* ---- cart ---- */
    function payload(r) {
      var v = variantFor(r);
      var props = {};
      if (r.props) Object.keys(r.props).forEach(function (k) { props[k] = r.props[k]; });
      if (r.contents) props['Contents'] = r.contents;
      var line = { id: v.id, quantity: r.quantity };
      if (Object.keys(props).length) line.properties = props;
      if (mode === 'subscribe' && r.plan && r.plan.id) line.selling_plan = r.plan.id;
      return { items: [line] };
    }
    function announce(cart, variantId) {
      // Tell the theme (header count, native drawer) and any listeners. Never force a
      // drawer open here: cart apps such as Upnova open their own on the add request,
      // and opening the theme's dialog as well locks the page behind two overlays.
      var detail = { resource: cart, sourceId: root.id, data: { source: 'buy-box', itemCount: cart && cart.item_count, variantId: String(variantId) } };
      try {
        var ev = new Event('cart:update', { bubbles: true });
        ev.detail = detail;
        document.dispatchEvent(ev);
      } catch (e) {}
      ['cart:refresh', 'cart:updated', 'ajaxProduct:added'].forEach(function (n) {
        try { document.dispatchEvent(new CustomEvent(n, { bubbles: true, detail: detail })); } catch (e) {}
      });
    }
    function add(button) {
      var r = current();
      if (!isAvailable(r)) return;
      var buttons = [el.cta, el.sticky && el.sticky.querySelector('[data-ayb="sticky-cta"]')].filter(Boolean);
      el.error.hidden = true;
      buttons.forEach(function (b) { b.disabled = true; });
      var body = payload(r);
      track('ayb_add_to_cart', { ayb_page: cfg.page, ayb_rung: r.key, ayb_rung_title: r.title, ayb_mode: mode, ayb_value: Math.round(totalFor(r) * 100) / 100, ayb_variant: body.items[0].id });
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
        .then(function (res) { return res.json().then(function (b) { return { ok: res.ok, body: b }; }); })
        .then(function (out) {
          buttons.forEach(function (b) { b.disabled = false; });
          render();
          if (!out.ok) {
            el.error.hidden = false;
            el.error.textContent = out.body.description || out.body.message || 'Could not add to cart.';
            track('ayb_error', { ayb_page: cfg.page, ayb_rung: r.key, ayb_message: el.error.textContent });
            return;
          }
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (res) { return res.json(); })
            .then(function (cart) { announce(cart, body.items[0].id); })
            .catch(function () { announce(null, body.items[0].id); });
        })
        .catch(function () {
          buttons.forEach(function (b) { b.disabled = false; });
          render();
          el.error.hidden = false;
          el.error.textContent = 'Something went wrong. Please try again.';
        });
    }

    /* ---- events ---- */
    root.addEventListener('click', function (e) {
      // Pill blurbs first: these only exist on the selected rung, and the click must
      // not bubble up and re-select the card underneath.
      var pill = e.target.closest('button.ayb-pill[data-tip]');
      if (pill && root.contains(pill)) {
        e.preventDefault();
        e.stopPropagation();
        var box = pill.closest('.ayb-rung').querySelector('[data-ayb="tip"]');
        if (!box) return;
        var text = pill.getAttribute('data-tip');
        var same = openTip === pill;
        Array.prototype.forEach.call(pill.parentNode.querySelectorAll('button.ayb-pill'), function (b) { b.setAttribute('aria-expanded', 'false'); });
        if (same) { box.hidden = true; openTip = null; return; }
        box.textContent = text;
        box.hidden = false;
        pill.setAttribute('aria-expanded', 'true');
        openTip = pill;
        return;
      }
      var m = e.target.closest('.ayb-mode');
      if (m && root.contains(m)) {
        mode = m.getAttribute('data-mode') === 'subscribe' && cfg.modes.subscribe ? 'subscribe' : 'onetime';
        track('ayb_mode_select', { ayb_page: cfg.page, ayb_mode: mode });
        render(); return;
      }
      var s = e.target.closest('.ayb-size');
      if (s && root.contains(s) && !s.disabled) {
        sizeId = s.getAttribute('data-size');
        track('ayb_size_select', { ayb_page: cfg.page, ayb_variant: sizeId });
        render(); syncGallery(); return;
      }
      var r = e.target.closest('.ayb-rung');
      if (r && root.contains(r)) {
        picked = r.getAttribute('data-key');
        track('ayb_rung_select', { ayb_page: cfg.page, ayb_rung: picked, ayb_mode: mode });
        render(); syncGallery();
      }
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openTip) {
        var box = openTip.closest('.ayb-rung').querySelector('[data-ayb="tip"]');
        if (box) box.hidden = true;
        openTip.setAttribute('aria-expanded', 'false');
        openTip.focus();
        openTip = null;
      }
    });
    el.rungs.addEventListener('keydown', function (e) {
      if (e.target.closest('button.ayb-pill')) return;
      if (['ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft', ' ', 'Enter'].indexOf(e.key) === -1) return;
      e.preventDefault();
      var keys = rungs.map(function (r) { return r.key; });
      var i = keys.indexOf(picked);
      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') i = (i + 1) % keys.length;
      if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') i = (i - 1 + keys.length) % keys.length;
      picked = keys[i]; render(); syncGallery();
      var f = el.rungs.querySelector('.ayb-rung.is-on'); if (f) f.focus();
    });
    el.cta.addEventListener('click', function () { add(el.cta); });
    if (el.sticky) {
      var sb = el.sticky.querySelector('[data-ayb="sticky-cta"]');
      if (sb) sb.addEventListener('click', function () { add(sb); });
      if ('IntersectionObserver' in window) {
        var stuck = false, nearFooter = false;
        function apply() { el.sticky.classList.toggle('is-stuck', stuck && !nearFooter); }
        new IntersectionObserver(function (entries) {
          var en = entries[0]; if (!en) return;
          stuck = !en.isIntersecting && en.boundingClientRect.bottom < 0;
          apply();
        }).observe(el.cta);
        var footer = document.querySelector('footer, [class*="footer-group"]');
        if (footer) {
          new IntersectionObserver(function (entries) {
            var en = entries[0]; if (!en) return;
            nearFooter = en.isIntersecting; apply();
          }, { rootMargin: '120px 0px 0px 0px' }).observe(footer);
        }
      }
    }

    render();
    (function () { var v = variantFor(current()); lastGalleryVariant = v && v.id; })();
    prefetchGalleries();
    track('ayb_view', { ayb_page: cfg.page, ayb_rungs: rungs.length, ayb_subscribe: !!cfg.modes.subscribe });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ayb-root]:not([data-ayb-ready])'), function (root) {
      root.setAttribute('data-ayb-ready', '1');
      try { BuyBox(root); } catch (e) { if (window.console) console.warn('buy-box', e); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', init);
  window.AYBBuyBox = { init: init };
})();